import * as actionTypes from 'modules/auditModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDIT_MODELS_MY]: isLoading,
  [actionTypes.FETCH_AUDIT_MODELS_MY_SUCCESS]: isEnded,
  [actionTypes.FETCH_AUDIT_MODELS_MY_FAILURE]: isEnded,
});
